/** 业务类型 枚举值 */
export const enum BUSINESS_TYPE {
  /** 普品 */
  NORMAL = 1,
  /** 首推 */
  FIRST = 2,
  /** 摇钱树 */
  CASH_COW = 3,
  /** 集采 */
  GROUP = 4,
  /** 控销 */
  CONTROL = 5
}

/** 业务类型 */
export const BUSINESS_TYPE_VALUE_LABEL = {
  [BUSINESS_TYPE.NORMAL]: '普品',
  [BUSINESS_TYPE.FIRST]: '首推',
  [BUSINESS_TYPE.CASH_COW]: '摇钱树',
  [BUSINESS_TYPE.GROUP]: '集采',
  [BUSINESS_TYPE.CONTROL]: '控销'
}

/** 业务类型下拉列表 */
export const BUSINESS_TYPE_OPTIONS = [
  {
    label: '普品',
    value: BUSINESS_TYPE.NORMAL
  },
  {
    label: '首推',
    value: BUSINESS_TYPE.FIRST
  },
  {
    label: '摇钱树',
    value: BUSINESS_TYPE.CASH_COW
  },
  {
    label: '集采',
    value: BUSINESS_TYPE.GROUP
  },
  {
    label: '控销',
    value: BUSINESS_TYPE.CONTROL
  }
]

export const enum DIALOG_BUSINESS_TYPE {
  /** 全部 */
  ALL = '0',
  /** 自营 */
  SELF_SUPPLIED = '1',
  /** 摇钱树 */
  CASH_COW = '2'
}

export const DIALOG_BUSINESS_TYPE_OPTIONS = [
  { value: DIALOG_BUSINESS_TYPE.ALL, label: '全部' },
  { value: DIALOG_BUSINESS_TYPE.SELF_SUPPLIED, label: '自营' },
  { value: DIALOG_BUSINESS_TYPE.CASH_COW, label: '摇钱树' }
]

/** SRM角色类型 */
export enum SRM_ROLE_TYPE {
  /** 管理员 */
  'ADMIN' = '1',
  /** 业务 */
  'BUSINESS' = '2',
  /** 财务 */
  'FINANCE' = '3',
  /** 质量 */
  'QUALITY' = '4'
}

/** SRM角色选项 */
export const SRM_ROLE_OPTIONS = [
  { value: SRM_ROLE_TYPE.ADMIN, label: '管理员' },
  { value: SRM_ROLE_TYPE.FINANCE, label: '财务' },
  { value: SRM_ROLE_TYPE.BUSINESS, label: '业务' },
  { value: SRM_ROLE_TYPE.QUALITY, label: '质量' }
]
